import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { householdsApi } from 'src/Services/API';
import { ApiError } from 'src/types/api-error.types';
import { HouseholdMemberDto } from 'src/types/household.types';

const useFetchEligibleHouseholdMembers = () => {
  const assetId = useCurrentAssetId();

  return useQuery<HouseholdMemberDto[], AxiosError<ApiError>>({
    queryKey: ['fetch-eligible-household-members', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return householdsApi.listEligibleMembers(assetId);
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchEligibleHouseholdMembers;
